/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ strani',
  jump_to: 'Pojdi na',
  jump_to_confirm: 'potrdi',
  page: '',

  // Pagination.jsx
  prev_page: 'PrejÅ¡nja stran',
  next_page: 'Naslednja stran',
  prev_5: 'PrejÅ¡njih 5 strani',
  next_5: 'Naslednjih 5 strani',
  prev_3: 'PrejÅ¡nje 3 strani',
  next_3: 'Naslednje 3 strani'
};
